import { render } from "./CButtonIcon.vue?vue&type=template&id=f116d108&scoped=true&ts=true"
import script from "./CButtonIcon.vue?vue&type=script&lang=ts"
export * from "./CButtonIcon.vue?vue&type=script&lang=ts"

import "./CButtonIcon.vue?vue&type=style&index=0&id=f116d108&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f116d108"]])

export default __exports__